import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { inputVariants } from '../../styles';
import { cn } from '../../utils';
export const TextInput = React.forwardRef(
// eslint-disable-next-line react/prop-types
({ className, type, ...props }, ref) => {
    return (_jsx("input", { type: type, className: cn(inputVariants(), 'w-full', className), ref: ref, ...props }));
});
TextInput.displayName = 'TextInput';
//# sourceMappingURL=TextInput.js.map